/*
创建者 魏强(2018.1.30)
中华老字号
*/
<template>
     <div id="zhlzh-page">
    	<div class="china-top" :style="{background:`url(${chinaTopBg})`}">
    		<img :src="chinaTopImg" alt="开心中华老字号" width="1268" height="150">
    	</div>
		<!-- banner -->
		<banner :data="banners"></banner>

		<div class="china-warpper" :style="{background:`url(${chinaBg})`}">
			<div class="wrapper">
		    	<!-- 优选特推 begin -->
		    	<optimization></optimization>
		        <!-- 优选特推 end -->

		        <!-- 文化传承 begin -->
		        <culture :data="youxuanList"></culture>
		        <!-- 文化传承 end -->

		        <!-- 汇集臻品 begin -->
		        <influx></influx>
		    </div>
		</div>
    </div>
</template>
<script>
import chinaTopImg from '../../assets/images/china/china-top.png';
import chinaTopBg from '../../assets/images/china/china-top-bg.png';
import chinaBg from '../../assets/images/china/china-bg.png';
import {zhlzhIndex} from 'api/home';
import banner from './banner';
import culture from './culture';
import optimization from './optimization';
import influx from './influx';
export default {
	components:{
		banner,
		culture,
		optimization,
		influx
	},
	data(){
		return{
			chinaTopImg,
			chinaTopBg,
			chinaBg,
			banners:[],
			youxuanList:[]
		}
	},
	created(){
		this.fetchZhlzhIndex();
	},
	methods:{
		fetchZhlzhIndex(){
			zhlzhIndex().then(json=>{
				const data = json.data;
				if(json.resCode==1){
					this.banners= data.banners;
					this.youxuanList= data.youxuanList;
				}else{
					console.log("中华老字号首页数据错误")
				}
			});
		}
	}
}
</script>

<style lang="less">
  @import "../../assets/css/zhlzh.less";
</style>



// WEBPACK FOOTER //
// index.vue?16645635